export interface Category {
  slug: string;
  name: string;
  icon: string;
  description: string;
}

export const categories: Category[] = [
  {
    slug: 'milk-powder',
    name: '奶粉辅食',
    icon: 'ri-cup-line',
    description: '全球精选优质奶粉，涵盖婴儿配方奶粉、幼儿成长奶粉及有机辅食系列，严选澳洲、新西兰、荷兰等优质奶源地品牌，为宝宝提供全面均衡的营养支持。',
  },
  {
    slug: 'diapers',
    name: '纸尿裤湿巾',
    icon: 'ri-drop-line',
    description: '汇集日本、韩国及欧美高端纸尿裤品牌，柔软亲肤、超强吸收，搭配天然温和婴儿湿巾，给宝宝全天候的干爽舒适体验。',
  },
  {
    slug: 'toys',
    name: '玩具益智',
    icon: 'ri-puzzle-line',
    description: '益智启蒙、感统训练、早教认知，精选全球知名玩具品牌，从新生儿到学龄前，用安全环保材质陪伴宝宝每一步成长探索。',
  },
  {
    slug: 'kids-clothing',
    name: '童装童鞋',
    icon: 'ri-t-shirt-line',
    description: '潮流童装、舒适童鞋，汇聚日韩欧美时尚童装品牌，纯棉亲肤面料，时尚设计与舒适穿着兼得，让宝贝穿出自信与活力。',
  },
  {
    slug: 'feeding',
    name: '喂养用品',
    icon: 'ri-store-2-line',
    description: '奶瓶奶嘴、吸奶器、辅食机、消毒器等一站式喂养装备，精选国际母婴大牌，科学设计助力轻松喂养，让育儿更省心。',
  },
  {
    slug: 'baby-care',
    name: '洗护用品',
    icon: 'ri-heart-pulse-line',
    description: '天然有机婴儿洗护系列，沐浴露、润肤乳、护臀膏等全线产品，温和无刺激配方，守护宝宝娇嫩肌肤，妈妈更安心。',
  },
];